import React, { Component } from 'react'
import { compose, graphql, withApollo } from 'react-apollo'
import { withRouter } from 'react-router'
import { get } from 'lodash'
import {
  ConfirmCodeModal,
  Veil,
  ModalDialog,
  Constants,
  Note,
  NoteSection,
  ProblemSection
} from '@sukiai/components'
import Editor from '@sukiai/quill-editor'
import {
  getScriptName,
  inNoteView,
  setModal,
  promptICD10Lookup,
  getPbSectionCtx,
  setToast,
  findDuplicates,
  getCompSectionFromCache,
  logout,
  cancelCreateNote,
  updateDiaognistics,
  getCompFromCache,
  cancelNoteSubmission,
  isAthena,
  isInIframe,
  isAmwellTheme
} from '../lib/util'
import {
  createComposition,
  submitComposition,
  submitCompositionBypassQa
} from '../recognition/ActionStream'
import ScriptEditor from './scriptEditor'
import NewSubmitModal from './NewSubmitModal'
import ICD10LookupModal from './ICD10LookupModal'
import SignOffModal from './SignOffModal'
import SettingsModal from './SettingsModal'
import {
  GET_MODAL,
  SET_MODAL,
  SET_MODAL_LOADING,
  SET_MODAL_DISMISS,
  GET_AGENT_STATE,
  GET_VEIL,
  GET_NOTES_LIST,
  SET_AGENT_POSITION,
  SET_AGENT_SIZE,
  CLEAR_SECTION,
  TOGGLE_VEIL,
  CLEAR_MODAL,
  GET_SCHEDULE_DATE,
  SET_COMP_BEING_DELETED,
  SET_AUDIO_STREAM_UI_CONTEXT,
  GET_DELETE_COMP_RES,
  GET_CURRENT_COMPOSITION
} from '../apollo/actions'
import {
  GetReadOnlyCompositionById,
  GetPatientNoteById,
  GetScript,
  UpdateComposition,
  BulkPrintPDFs,
  BulkSavePDFs,
  GetSections,
  GetNoteTypeById,
  AddToPatientList,
  CreateOrUpdateAppointment
} from '@sukiai/gql/app'
import loSto from '../config/loSto'
import {
  deleteNote,
  deleteProblemSection,
  LO_STO,
  ROUTES,
  setError,
  HALF_STORY,
  printCurrentNote,
  setSubmissionWarningModal,
  FETCH_POLICY,
  DISAMBIG,
  SUKI_ROLE,
  MODAL_STRINGS,
  SESH_STO,
  APPOINTMENT_TYPES
} from '../lib'

import { logger, halfStory as hs, logIntercomEvent } from '../lib/logging'
import { sendSpeechConfig } from '../ws/stream'
import {
  CONFIRM_STATUS,
  INTERCOM_EVENTS,
  INACTIVITY_TIMEOUT,
  CURRENT_SECTION,
  EMR_DESTINATION
} from '../lib/constants'
import IdleTimer from 'react-idle-timer'
import { AGENT } from '@sukiai/components/lib/constants'
import NewScriptModal from './newScriptModal'
import seshSto from '../config/seshSto'
import EmrNotePullDialog from './EmrNotePullDialog'
import NotetypeEditor from './NotetypeEditor'
import omitDeep from 'omit-deep-lodash'
import AmwellScripts from './embedScripts/components/amwellScripts'

const { MODALS, NOTES, TOAST } = Constants
const PRINT_KEY = 'p'
const noEventListenerList = [MODALS.ICD10_SEARCH]

class VeilContainer extends Component {
  constructor (props) {
    super(props)

    this.idleTimer = null
  }

  state = {
    shouldDismiss: false,
    dismissVeil: true,
    compositionOrNoteData: null,
    hasSubmissionWarning: false,
    editMode: false,
    script: {},
    sectionNames: [],
    shouldBypassQa: false
  }

  componentDidMount () {
    const { modal } = this.props
    const type = get(modal, 'content.type')

    if (type === MODALS.READ_NOTE) {
      this.getCurrentNote()
    }

    if (!noEventListenerList.includes(type)) {
      window.addEventListener('keydown', this.handleKeyDown)
    }
  }

  componentWillUnmount () {
    const { modal } = this.props
    const type = get(modal, 'content.type')
    if (!noEventListenerList.includes(type)) {
      window.removeEventListener('keydown', this.handleKeyDown)
    }
  }

  handleKeyDown = e => {
    if (
      e.metaKey &&
      e.key === PRINT_KEY &&
      (loSto.get(LO_STO.CURRENT_COMP_ID) || loSto.get(LO_STO.CURRENT_NOTE_ID))
    ) {
      e.preventDefault()
      printCurrentNote()
    }
  }

  componentWillReceiveProps (nextProps) {
    if (
      nextProps.modal.open &&
      !this.props.modal.open &&
      !this.state.shouldDismiss
    ) {
      this.logModalOpen(true, nextProps.modal)
      this.props.toggleVeil(true)

      if (nextProps.modal.content.type !== this.props.modal?.content?.type) {
        sendSpeechConfig('Modal was opened')
      }
    }

    if (
      nextProps.modal?.open && this.props.modal?.open &&
      this.props.modal?.content?.type !== nextProps.modal?.content?.type
    ) {
      sendSpeechConfig('Secondary modal was opened')
    }

    if (
      nextProps.modal.content &&
      nextProps.modal.content.type === MODALS.READ_NOTE
    ) {
      if (nextProps.modal.content !== this.props.modal.content) {
        this.getCurrentNote()
      }
    }

    if (nextProps.modal.shouldDismiss) {
      this.dismiss()
    }

    if (
      nextProps.modal.open &&
      nextProps.location &&
      nextProps.location.pathname !== this.props.location.pathname
    ) {
      // closes modal if we navigate away from page
      this.setState({
        shouldDismiss: true,
        dismissVeil: true
      })
    }

    // When agent is muted
    if (
      nextProps.agentState === AGENT.STATE.MUTED &&
      this.props.agentState !== AGENT.STATE.MUTED
    ) {
      this.idleTimer.reset()
      this.idleTimer.resume()
    }

    // When agent is unmuted
    if (
      nextProps.agentState !== AGENT.STATE.MUTED &&
      this.props.agentState === AGENT.STATE.MUTED
    ) {
      this.idleTimer.pause()
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const shouldPostMessage = prevProps.modal.content.selectType !== DISAMBIG.CREATE_NOTE_NOTETYPE &&
      this.props.modal.content.selectType === DISAMBIG.CREATE_NOTE_NOTETYPE

    if (isInIframe && shouldPostMessage) {
      window.parent.postMessage('suki-notetype-selector-loaded', '*')
    }
  }

  async getEmrEncounterId () {
    const currentCompId = loSto.get(LO_STO.CURRENT_COMP_ID)
    const cachedSection = await getCompFromCache(currentCompId)

    return get(
      cachedSection,
      'metadata.appointment.emrEncounterId'
    )
  }

  logModalOpen = (open, modal) => {
    let description = `${open ? 'Opening' : 'Closing'} ${modal.content &&
      modal.content.type} modal`

    if (modal.content.type === MODALS.SELECT) {
      description = description.concat(` for ${modal.content.selectType}`)
    }

    hs.add(HALF_STORY.MODAL, description)
  }

  // renderEditor returns our Editor component with the persona set as Admin to
  // ensure that the read-only note does not display any blurred text
  renderEditor = content => (
    <Editor value={content} persona={SUKI_ROLE.ADMIN} readOnly />
  )

  getCurrentNote = () => {
    const { client } = this.props
    if (loSto.get(LO_STO.CURRENT_NOTE_ID)) {
      console.info(`Getting Patient Note: ${loSto.get(LO_STO.CURRENT_NOTE_ID)}`)
      client
        .query({
          query: GetPatientNoteById,
          variables: { id: loSto.get(LO_STO.CURRENT_NOTE_ID) },
          fetchPolicy: FETCH_POLICY.NETWORK_ONLY
        })
        .then(({ data }) => {
          if (data.patientNotes) {
            const fetchedNote = data.patientNotes.results[0]
            const currentNote = {}
            currentNote.sections = fetchedNote.sections.map(s => {
              if (s.diagnosisEntry === null) {
                return (
                  <NoteSection
                    key={s.id}
                    editor={this.renderEditor(s.content)}
                    {...s}
                  />
                )
              } else {
                const icdCode = get(s, 'diagnosisEntry.diagnosis.icdCode')
                return (
                  <ProblemSection
                    id={s.id}
                    key={s.id}
                    editor={this.renderEditor(s.content)}
                    {...s}
                    icdCode={icdCode}
                    isReadOnly
                  />
                )
              }
            })
            currentNote.metadata = fetchedNote.metadata
            this.setState({ compositionOrNoteData: currentNote })
          }
        })
        .catch(err => {
          console.error('Error getting note:', err)
          setTimeout(() => {
            setError('Could not get note. Please try again.')
          }, 200)
        })
    } else {
      console.info(`Getting Composition: ${loSto.get(LO_STO.CURRENT_COMP_ID)}`)
      client
        .query({
          query: GetReadOnlyCompositionById,
          variables: { id: loSto.get(LO_STO.CURRENT_COMP_ID) },
          fetchPolicy: FETCH_POLICY.NETWORK_ONLY
        })
        .then(({ data }) => {
          if (data.compositions) {
            const fetchedComp = data.compositions.results[0]
            const currentComp = {}
            currentComp.sections = fetchedComp.sections.map(s => (
              <NoteSection
                key={s.id}
                editor={this.renderEditor(s.content)}
                {...s}
              />
            ))
            currentComp.metadata = fetchedComp.metadata
            this.setState({ compositionOrNoteData: currentComp })
          }
        })
        .catch(err => {
          console.error('Error getting note:', err)
          setTimeout(() => {
            setError('Could not get note. Please try again.')
          }, 200)
        })
    }
  }

  dismissOnCancel = async () => {
    const { modal } = this.props
    if (modal.open) {
      const isCreateNotype = modal?.content?.selectType === DISAMBIG.CREATE_NOTE_NOTETYPE
      if (isCreateNotype) {
        const compId = loSto.get(LO_STO.CURRENT_COMP_ID)
        cancelCreateNote(compId)
      }

      const modalType = modal?.content?.type

      if (modalType === MODALS.EMR_NOTE_PULL) {
        console.info('Do nothing on veil click while waiting for emr note pull')
        return
      }

      if (
        modalType === MODALS.IM_DONE ||
        modalType === MODALS.SUBMIT_OPTIONS ||
        modalType === MODALS.IM_DONE_BYPASS_QA ||
        modalType === MODALS.PDF_SUBMIT ||
        modalType === MODALS.NO_ENCOUNTER ||
        modalType === MODALS.IM_DONE_PDF ||
        modalType === MODALS.SIGN_OFF
      ) {
        const compId = loSto.get(LO_STO.CURRENT_COMP_ID)
        const comp = await getCompFromCache(compId)
        cancelNoteSubmission(comp)
      }

      this.dismiss()
    }
  }

  shouldMoveAgentToMiddle = (route) => {
    const restrictedRoutes = [ROUTES.NOTE, ROUTES.UNFINISHED_NOTES, ROUTES.PATIENT_NOTES, ROUTES.HELP, ROUTES.SCHEDULE]
    return restrictedRoutes.every(restricted => !route.includes(restricted))
  }

  dismiss = async () => {
    const { modal, setAgentPosition, setAgentSize, history } = this.props

    if (modal.open) {
      this.logModalOpen(false, modal)

      // Reset the following values only if leaving the note view
      if (!window.location.pathname.includes(ROUTES.NOTE)) {
        this.shouldMoveAgentToMiddle(window.location.pathname) && setAgentPosition(loSto.get(LO_STO.LAST_AGENT_POSITION))
        this.shouldMoveAgentToMiddle(window.location.pathname) && setAgentSize(loSto.get(LO_STO.LAST_AGENT_SIZE))

        loSto.remove(LO_STO.CURRENT_APPT_ID)

        loSto.remove(LO_STO.SUBMISSION_WARNING)
        loSto.remove(LO_STO.SUBMISSION_WARNING_MSG)
      }

      loSto.remove(LO_STO.CURRENT_NOTETYPE_ID)
      loSto.remove(LO_STO.CURRENT_NOTE_ID)

      // If the modal dismiss is hit but still on the note view or patient note view then
      // dont remove the patient id.
      if (
        !window.location.pathname.includes(ROUTES.PATIENT_NOTES) &&
        !window.location.pathname.includes(ROUTES.NOTE)
      ) {
        loSto.remove(LO_STO.CURRENT_PATIENT_ID)
      }

      this.setState({
        shouldDismiss: true,
        compositionOrNoteData: null,
        shouldBypassQa: false
      })

      if (this.state.hasSubmissionWarning) {
        history.push(ROUTES.SCHEDULE)
        this.setState({
          hasSubmissionWarning: false
        })
      }
    }
  }

  readOnlyDismiss = () => {
    console.debug('Handling read-only dismiss')
    setTimeout(() => {
      if (loSto.get(LO_STO.READ_ONLY_NOTE_CLICKED)) {
        console.debug('Not dismissing, read-only state.')
      } else {
        this.dismiss()
      }
    }, 800)
    loSto.set(LO_STO.READ_ONLY_NOTE_CLICKED, false)
  }

  handleNoteWrapperClick = () => {
    loSto.set(LO_STO.READ_ONLY_NOTE_CLICKED, true)
  }

  removeModal = () => {
    const { clearModal, toggleVeil } = this.props
    this.setState({ shouldDismiss: false })

    if (this.state.dismissVeil) {
      toggleVeil(false)
    } else {
      this.setState({ dismissVeil: true })
    }

    clearModal().then(() => {
      sendSpeechConfig('Modal was closed.')
    })
  }

  onDeleteNote = () => {
    const {
      clearCurrentSection,
      setCompBeingDeleted,
      setModalLoading
    } = this.props

    clearCurrentSection()
    setCompBeingDeleted(true)
    setModalLoading()
    const currentCompId = loSto.get(LO_STO.CURRENT_COMP_ID)

    hs.add(HALF_STORY.CLICK, `Deleting note ${currentCompId}`)

    deleteNote(currentCompId)
  }

  onAddPatientToList = () => {
    const { addToPatientList, client } = this.props
    const { composition } = client.readQuery({
      query: GET_CURRENT_COMPOSITION
    })
    const comp = JSON.parse(composition, null, 2)
    const patient = get(comp, 'metadata.patient')

    addToPatientList({
      variables: {
        patient,
        userId: loSto.get(LO_STO.USER_ID),
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID)
      }
    }).then(data => {
      this.dismiss()
      setToast(TOAST.TYPE.PRIMARY, 'Patient added to your list', TOAST.DURATION.SHORT)
    }).catch(err => {
      setToast(TOAST.TYPE.ERROR, 'Sorry, couldn’t add patient to your list', TOAST.DURATION.MEDIUM)
      logger.error('Unable to add patient to list', err)
    })
  }

  onAddPatientToSchedule = () => {
    const { updateAppointment, client } = this.props
    const { composition } = client.readQuery({
      query: GET_CURRENT_COMPOSITION
    })
    const comp = JSON.parse(composition, null, 2)
    const appointment = get(comp, 'metadata.appointment')
    const { id, startsAt, endsAt } = appointment

    updateAppointment({
      variables: {
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        appointment: {
          id,
          startsAt,
          endsAt,
          ownerId: get(appointment, 'owner.id'),
          patientId: get(appointment, 'patient.id'),
          type: APPOINTMENT_TYPES.NON_EMR_USER_GENERATED
        }
      }
    }).then(data => {
      this.dismiss()
      setToast(TOAST.TYPE.PRIMARY, 'Patient added to your schedule', TOAST.DURATION.SHORT)
    }).catch(err => {
      setToast(TOAST.TYPE.ERROR, 'Sorry, couldn’t add patient to your Schedule', TOAST.DURATION.MEDIUM)
      logger.error('Unable to add patient to schedule', err)
    })
  }

  onClickUnfinishedNote = () => {
    this.props.history.push(ROUTES.UNFINISHED_NOTES)
  }

  icd10Search = () => {
    const { client } = this.props
    const type = MODALS.ICD10_SEARCH

    client.mutate({
      mutation: SET_MODAL,
      variables: {
        content: { __typename: 'ModalContent', type }
      }
    })
  }

  onDeleteDiagnosis = async () => {
    // log action
    const { modal } = this.props
    const { id: sectionId } = get(modal, 'content.items')[0]
    hs.add(HALF_STORY.CLICK, `Deleting ICD10Code from Section: ${sectionId}`)

    this.updateDiagnosis({
      icdCode: '',
      description: '',
      snomedCode: '',
      billable: false
    }, CONFIRM_STATUS.UNCONFIRMED)

    const compId = loSto.get(LO_STO.CURRENT_COMP_ID)
    const cachedSection = await getCompSectionFromCache(compId, sectionId)

    cachedSection.diagnosisEntry = {
      diagnosis: {
        icdCode: '',
        description: '',
        snomedCode: '',
        billable: false
      },
      confirmStatus: CONFIRM_STATUS.UNCONFIRMED
    }

    cachedSection.updateType = 'ONLY_DIAGNOSIS'

    await updateDiaognistics(cachedSection)
  }

  onUpdateDiagnosis = async ({ icdCode, description, snomedCode, billable }) => {
    // log action
    const { modal } = this.props
    const { id: sectionId } = get(modal, 'content.items')[0]
    hs.add(HALF_STORY.CLICK, `Adding ICD10Code to Section: ${sectionId}`)

    await this.updateDiagnosis({ icdCode, description, snomedCode, billable }, CONFIRM_STATUS.CONFIRMED)
  }

  updateDiagnosis = async ({ icdCode, description, snomedCode, billable }, confirmStatus) => {
    const { client, modal } = this.props
    // get values passed from modal
    const { id: sectionId } = get(modal, 'content.items')[0]

    // try to get from cache
    const compId = loSto.get(LO_STO.CURRENT_COMP_ID)
    const cachedSection = await getCompSectionFromCache(compId, sectionId)
    const problemLabel = icdCode ? cachedSection.name : ''

    // use values from cache if exists else use values provided
    // const cachedSection.name = cachedSection.name || name
    // const updatedContent = cachedSection.content || content
    cachedSection.diagnosisEntry = {
      diagnosis: {
        icdCode,
        snomedCode,
        billable,
        description,
        problemLabel
      },
      confirmStatus
    }

    cachedSection.updateType = 'ONLY_DIAGNOSIS'

    await updateDiaognistics(cachedSection)

    confirmStatus === CONFIRM_STATUS.UNCONFIRMED && client.mutate({ mutation: SET_MODAL_DISMISS })
  }

  onSubmitNoteBypassQa = () => {
    this.onSubmitNote(false, false, true)
    logIntercomEvent(INTERCOM_EVENTS.NOTE_BYPASS_OPS)
  }

  onDeleteProblemSection = async (orgId, compId, sectionId) => {
    const { setAudioStreamContext, client } = this.props

    await deleteProblemSection(sectionId)
    client.mutate({ mutation: SET_MODAL_DISMISS })

    setAudioStreamContext({
      problemBasedSections: await getPbSectionCtx(compId)
    }).then(() => {
      // restart audio to make sure noteId makes it to streaming-gateway
      sendSpeechConfig('Problem based section has been deleted')
    })
  }

  onSubmitNote = (tryAllDestinations, pdfSubmitOnSubmissionError = false, bypassQa = true) => {
    const {
      clearCurrentSection,
      setModalLoading
      // setModalDismiss
    } = this.props

    const [primaryDestination, secondaryDestination] = loSto.get(
      LO_STO.SUBMISSION_DESTINATIONS
    )

    clearCurrentSection()
    const currentCompId = loSto.get(LO_STO.CURRENT_COMP_ID)

    hs.add(HALF_STORY.CLICK, `Submitting note ${currentCompId}`)

    setModalLoading()

    if (
      primaryDestination !== EMR_DESTINATION.DOCUMENT &&
      secondaryDestination === EMR_DESTINATION.DOCUMENT &&
      !pdfSubmitOnSubmissionError
    ) {
      tryAllDestinations = false
      loSto.set(LO_STO.SUBMISSION_TRY_ALL_DESTINATION, false)
    } else {
      tryAllDestinations = true
      loSto.set(LO_STO.SUBMISSION_TRY_ALL_DESTINATION, true)
    }

    let submit = null
    if (bypassQa || this.state.shouldBypassQa) {
      submit = submitCompositionBypassQa
    } else {
      submit = submitComposition
    }
    submit({
      id: currentCompId,
      tryAllDestinations
    })

    /* submit({
      variables: {
        id: currentCompId,
        tryAllDestinations
      },
      update: (cache, response) => {
        const submissionStatus = get(
          response,
          'data.submitComposition.submissionStatus'
        )

        try {
          const noteData = get(
            cache.readQuery({
              query: GetCompositionById,
              variables: { id: currentCompId }
            }),
            'compositions.results[0]'
          )

          noteData.metadata.submissionStatus = { ...submissionStatus }

          cache.writeQuery({
            query: GetCompositionById,
            variables: { id: currentCompId },
            data: noteData
          })

          const apptsData = cache.readQuery({
            query: GetAppointments,
            variables: {
              ownerId: loSto.get(LO_STO.USER_ID),
              startsAtRangeBeginning: moment(scheduleDate)
                .startOf('day')
                .toISOString(),
              startsAtRangeEnd: moment(scheduleDate)
                .endOf('day')
                .toISOString()
            }
          })
          const idx = apptsData.appointments.results.findIndex(
            a => a.compositionId === currentCompId
          )
          if (idx === -1) return
          apptsData.appointments.results[idx].noteStatus =
            NOTE_STATUS.USER_IS_DONE
          cache.writeQuery({
            query: GetAppointments,
            variables: {
              ownerId: loSto.get(LO_STO.USER_ID),
              startsAtRangeBeginning: moment(scheduleDate)
                .startOf('day')
                .toISOString(),
              startsAtRangeEnd: moment(scheduleDate)
                .endOf('day')
                .toISOString()
            },
            data: apptsData
          })
        } catch (e) {
          console.error('Could not find appointments in cache')
        }
      },
      refetchQueries: [
        {
          query: GetUnfinishedCompositionsCount,
          variables: { userId: loSto.get(LO_STO.USER_ID) }
        },
        {
          query: GetUnfinishedCompositions,
          variables: { userId: loSto.get(LO_STO.USER_ID) }
        },
        {
          query: GetAllNotes,
          variables: {
            userId: loSto.get(LO_STO.USER_ID),
            patientId: loSto.get(LO_STO.CURRENT_PATIENT_ID)
          }
        },
        {
          query: GetAppointments,
          variables: {
            ownerId: loSto.get(LO_STO.USER_ID),
            startsAtRangeBeginning: moment(scheduleDate)
              .startOf('day')
              .toISOString(),
            startsAtRangeEnd: moment(scheduleDate)
              .endOf('day')
              .toISOString()
          }
        }
      ]
    })
      .then(({ data }) => {
        const submissionStatus = get(data, 'submitComposition.submissionStatus')
        const submissionStatusWarning = get(submissionStatus, 'warning.message')

        // TODO: This is a special case handling for the no_encounter warning - but a larger
        // refactoring of submission warning logic is necessary. A state machine would benefit us.
        // If warning is already set in loSto, its already been handled
        const loStoSubmissionWarning = loSto.get(LO_STO.SUBMISSION_WARNING)
        const isNoEncounterWarning = loStoSubmissionWarning === SUBMISSION_WARNING.NO_ENCOUNTER

        // If we get a Submission Status Warning in the response, set it in loSto
        if (submissionStatusWarning) {
          loSto.set(
            LO_STO.SUBMISSION_WARNING,
            get(submissionStatus, 'warning.type')
          )
          loSto.set(
            LO_STO.SUBMISSION_WARNING_MSG,
            get(submissionStatus, 'warning.message')
          )
        }

        if (submissionStatusWarning && !isNoEncounterWarning) {
          this.setState({
            hasSubmissionWarning: true,
            shouldBypassQa: !!bypassQa
          })
          setSubmissionWarningModal()
        } else {
          this.dismiss()
          console.info('Submitted Note')
          recordNoteUpdated('USER_IS_DONE')
          history.push(ROUTES.SCHEDULE)
        }
      })
      .catch(err => {
        this.dismiss()
        console.error('Error submitting note:', err)
        setTimeout(() => {
          setError('Could not submit note. Please try again.')
        }, 400)
      }) */
  }

  onSignOff = () => {
    // Submit to Suki
    const shouldBypass = loSto.get(LO_STO.SHOULD_BYPASS_QA)
    loSto.set(LO_STO.SHOULD_BYPASS_QA, false)
    logIntercomEvent(INTERCOM_EVENTS.NOTE_SUKI_PROCESS_FIRST)
    this.onSubmitNote(false, false, shouldBypass)
  }

  goToProfile = patientId => {
    const currentPatientId = loSto.get(LO_STO.CURRENT_PATIENT_ID)
    if (currentPatientId === patientId) {
      // Not navigating to a new page, but should dismiss modal
      this.dismiss()
      return
    }
    hs.add(HALF_STORY.CLICK, `Going to profile for patient ${patientId}`)
    const { history, setAudioStreamUIContext } = this.props
    history.push(`${ROUTES.PATIENT_NOTES}/${patientId}`)

    setAudioStreamUIContext({
      patientId
    }).then(() => sendSpeechConfig('patient profile selection'))
  }

  openScript = async id => {
    const { client } = this.props

    let res
    try {
      res = await client.query({
        query: GetScript,
        variables: { id }
      })
    } catch (err) {
      console.error('Could not get script', err)
      return
    }

    const script = get(res, 'data.macros.results[0]')
    const scriptName = getScriptName(script)

    let sectionsRes
    try {
      sectionsRes = await client.query({
        query: GetSections,
        variables: {
          organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
          withMapping: false
        }
      })
    } catch (err) {
      console.error('Could not get script', err)
      return
    }

    let allSections = sectionsRes?.data?.sections?.results
    allSections = [CURRENT_SECTION, ...allSections]

    this.setState({
      script: script,
      items: allSections
    })

    client.mutate({
      mutation: SET_MODAL,
      variables: {
        content: {
          __typename: 'ModalContent',
          type: MODALS.SCRIPT_DETAILS,
          heading: scriptName,
          content: {
            __typename: 'ModalContent',
            items: allSections
          }
        }
      }
    })
  }

openNoteType = async id => {
  const { client } = this.props

  let res
  try {
    res = await client.query({
      query: GetNoteTypeById,
      variables: {
        id,
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID)
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    })
  } catch (err) {
    console.error('Could not get notetype', err)
    return
  }

  const noteType = get(res, 'data.noteTypes.results[0]')

  const cleanedNoteTypeSections = noteType.sections.map(s => {
    const newSection = { ...s }
    newSection.id = newSection.sectionId
    delete newSection.sectionId
    return omitDeep(newSection, '__typename')
  })

  const cleanedNoteType = { ...noteType, sections: cleanedNoteTypeSections }

  let sectionsRes
  try {
    sectionsRes = await client.query({
      query: GetSections,
      variables: {
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        withMapping: true
      }
    })
  } catch (err) {
    console.error('Could not get script', err)
    return
  }

  let sections = sectionsRes?.data?.sections?.results || []
  if (isAthena()) {
    sections = sections.filter(s => !!s.emrMapping)
  }

  this.setState({
    noteType: cleanedNoteType,
    items: sections
  })

  client.mutate({
    mutation: SET_MODAL,
    variables: {
      content: {
        __typename: 'ModalContent',
        type: MODALS.NOTETYPE_DETAIL,
        heading: noteType?.name,
        content: {
          __typename: 'ModalContent',
          items: sections
        }
      }
    }
  })
}

  goToConfirm = () => {
    return setModal(
      MODALS.CONFIRM_CODES
    )
  }

  onContinue = () => {
    logIntercomEvent(INTERCOM_EVENTS.USED_PBN)
    return setModal(
      MODALS.SUBMIT_OPTIONS,
      MODAL_STRINGS.IM_DONE_BYPASS_QA_HEADING,
      MODAL_STRINGS.IM_DONE_BYPASS_QA_BODY
    )
  }

  onClickBulkSaveNotes = () => {
    const {
      compositionIds,
      patientNoteIds,
      client,
      setModalLoading
    } = this.props

    setModalLoading()
    client.query({
      query: BulkSavePDFs,
      variables: {
        compositionIds,
        patientNoteIds
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    }).then(({ data }) => {
      const uri = get(data, 'bulkSavePDFs.zip.uri')
      if (uri) {
        window.open(uri, '_blank')
        this.dismiss()
      } else {
        setError('Could not save notes. Please try again later.')
      }
    }).catch(err => {
      console.error('Could not save notes:', err)
      setError('Could not save notes. Please try again later.')
    })
  }

  onClickBulkPrintNotes = () => {
    const {
      compositionIds,
      patientNoteIds,
      client,
      setModalLoading
    } = this.props

    setModalLoading()
    client.query({
      query: BulkPrintPDFs,
      variables: {
        compositionIds,
        patientNoteIds
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    }).then(({ data }) => {
      const uri = get(data, 'bulkPrintPDFs.pdf.uri')
      if (uri) {
        window.open(uri, '_blank')
        this.dismiss()
      } else {
        setError('Could not print notes. Please try again later.')
      }
    }).catch(err => {
      console.error('Could not print notes:', err)
      setError('Could not print notes. Please try again later.')
    })
  }

  onInactiveTimeout = () => {
    const userId = loSto.get(LO_STO.USER_ID)
    console.info(`User [${userId}] has been inactive for 15 minutes. Automatically signing out.`)
    logger.info(`User [${userId}] has been inactive for 15 minutes. Automatically signing out.`)
    logout()
  }

  handleOnIdle = () => {
    if (isAmwellTheme()) {
      return
    }
    this.props.setModal({
      __typename: 'ModalContent',
      type: MODALS.INACTIVITY_TIMEOUT,
      heading: 'Stay signed in?',
      body: 'You haven’t used Suki for 15 minutes, so to help with security we’ll sign you out.'
    })
  }

  handleOnAction = () => {
    this.idleTimer.reset()
  }

  createNewScript = () => {
    const { client } = this.props

    const organizationId = seshSto.session(SESH_STO.CURRENT_ORGANIZATION)?.id
    const sectionVariables = { organizationId, withMapping: false }

    client.query({
      query: GetSections,
      variables: sectionVariables
    }).then(({ data }) => {
      const sections = data?.sections?.results
      const sectionsWithCurrent = [CURRENT_SECTION, ...sections]
      this.setState({ items: sectionsWithCurrent })
      this.props.setModal({
        __typename: 'ModalContent',
        type: MODALS.NEW_SCRIPT,
        heading: 'New Script',
        body: 'Insert New Script', // does not get displayed
        content: {
          __typename: 'ModalContent',
          items: sectionsWithCurrent
        }
      })
    })
  }

  createNewNoteType = () => {
    const { client } = this.props

    const organizationId = seshSto.session(SESH_STO.CURRENT_ORGANIZATION)?.id
    const sectionVariables = { organizationId, withMapping: true }

    client.query({
      query: GetSections,
      variables: sectionVariables
    }).then(({ data }) => {
      let sections = data?.sections?.results || []
      if (isAthena()) {
        sections = sections.filter(s => !!s.emrMapping)
      }
      this.setState({ items: sections }, () => {
        this.props.setModal({
          __typename: 'ModalContent',
          type: MODALS.NEW_NOTETYPE,
          heading: 'New Script',
          body: 'Insert New Notetype'
        })
      })
    })
  }

  redirectToSchedule = () => {
    const { history } = this.props
    history.push(ROUTES.SCHEDULE)
  }

  // TODO: sorely needs default props or typescript
  render () {
    const { active, modal, client } = this.props
    const { compositionOrNoteData, script, items, noteType } = this.state
    const type = get(modal, 'content.type')

    // The action to be preformed when an item in the modal is clicked
    let handleSelect = () => {}
    if (type === MODALS.SELECT) {
      const selectType = get(modal, 'content.selectType')
      switch (selectType) {
        case DISAMBIG.CREATE_NOTE_NOTETYPE:
        case DISAMBIG.CREATE_NOTE_PATIENT:
          handleSelect = id => {
            this.setState({ selectedNoteTypeId: id })
            createComposition(id, loSto.get(LO_STO.CURRENT_PATIENT_ID), loSto.get(LO_STO.CURRENT_APPT_ID))
          }
          break
        case DISAMBIG.PATIENT_PROFILE:
          handleSelect = this.goToProfile
          break
        case DISAMBIG.SCRIPTS:
          handleSelect = id => this.openScript(id)
          break
        case 'NOTETYPES':
          handleSelect = id => this.openNoteType(id)
          break
        default:
          break
      }
    }

    let secondaryHeader = null
    if (
      type === MODALS.SELECT &&
      get(modal, 'content.selectType') === DISAMBIG.SCRIPTS &&
      inNoteView()
    ) {
      secondaryHeader = isAmwellTheme() ? (
        <div
          style={{
            color: '#bec3cc',
            fontSize: '16px',
            lineHeight: '1.26em'
          }}
        >
          Say "Suki insert..."
        </div>
      ) : (
        <div
          style={{
            color: 'rgb(41, 64, 79)',
            fontSize: '16px'
          }}
        >
          "<b>Suki</b> insert..."
        </div>
      )
    }

    // The action to be preformed when dismissing the modal
    let dismiss = () => {}
    switch (type) {
      case MODALS.READ_NOTE:
        dismiss = this.readOnlyDismiss
        break
      default:
        dismiss = this.dismissOnCancel
        break
    }

    let modalContent = null
    let disableClickToDismiss = false
    switch (type) {
      case MODALS.ICD10_PREVIEW:
      {
        modalContent = (
          <ModalDialog
            open={modal.open}
            shouldDismiss={this.state.shouldDismiss}
            loading={modal.loading}
            {...modal.content}
            removeModal={this.removeModal}
            dismiss={this.dismissOnCancel}
            icd10Search={this.icd10Search}
            deleteDiagnosis={this.onDeleteDiagnosis}
          />
        )

        break
      }
      case MODALS.ICD10_SEARCH:
      {
        const { name } = get(modal, 'content.items')[0]
        const fromConfirm = get(modal, 'content.data.fromConfirm', false)
        const currentPatientId = loSto.get(LO_STO.CURRENT_PATIENT_ID)
        const emrEncounterId = this.getEmrEncounterId()

        modalContent = (
          <ICD10LookupModal
            sectionName={name}
            patientId={currentPatientId}
            emrEncounterId={emrEncounterId}
            removeModal={this.removeModal}
            dismiss={this.dismissOnCancel}
            updateDiagnosis={this.onUpdateDiagnosis}
            shouldDismiss={this.state.shouldDismiss}
            open={modal.open}
            fromConfirm={fromConfirm}
            goToConfirm={this.goToConfirm}
          />
        )
        break
      }
      case MODALS.SETTINGS:
      {
        const selectType = get(modal, 'content.selectType')
        modalContent = (
          <SettingsModal
            modalOpen={modal.open}
            shouldDismiss={this.state.shouldDismiss}
            dismiss={this.dismissOnCancel}
            open={modal.open}
            removeModal={this.removeModal}
            openScriptDetails={this.openScript}
            setCurrentScript={script => {
              this.setState({ script })
            }}
            setAgentPosition={this.props.setAgentPosition}
            handleCreateNewScript={this.createNewScript}
            openNotetype={this.openNoteType}
            handleAddNotetype={this.createNewNoteType}
            selectType={selectType}
          />
        )
        break
      }
      case MODALS.READ_NOTE:
      {
        const isProcessing = get(modal, 'content.data.isProcessing')

        modalContent = (
          <Note
            modalOpen={modal.open}
            shouldDismiss={this.state.shouldDismiss}
            type={NOTES.READ_ONLY}
            removeModal={this.removeModal}
            onNoteWrapperClick={this.handleNoteWrapperClick}
            isProcessing={isProcessing}
            {...compositionOrNoteData}
          />
        )
        break
      }
      case MODALS.SCRIPT_DETAILS:
      {
        modalContent = (
          <ScriptEditor
            scriptId={script.id}
            modal={modal}
            shouldDismiss={this.state.shouldDismiss}
            open={modal.open}
            removeModal={this.removeModal}
            dismiss={this.dismissOnCancel}
            script={script}
            allSections={items}
          />
        )
        disableClickToDismiss = true
        break
      }
      case MODALS.AMWELL_SCRIPTS: {
        modalContent = (
          <AmwellScripts
            onSelect={this.openScript}
            createScript={this.createNewScript}
          />
        )
        disableClickToDismiss = true
        break
      }
      case MODALS.SUBMIT_OPTIONS:
      {
        modalContent = (
          <NewSubmitModal
            open={modal.open}
            shouldDismiss={this.state.shouldDismiss}
            loading={modal.loading}
            {...modal.content}
            removeModal={this.removeModal}
            dismiss={this.dismissOnCancel}
            submitNote={this.onSubmitNote}
            handleSubmitNoteBypassQa={this.onSubmitNoteBypassQa}
            onSelect={handleSelect}
          />
        )
        break
      }
      case MODALS.SIGN_OFF:
        modalContent = (
          <SignOffModal
            open={modal.open}
            shouldDismiss={this.state.shouldDismiss}
            loading={modal.loading}
            {...modal.content}
            removeModal={this.removeModal}
            dismiss={this.dismissOnCancel}
            handleSignOff={this.onSignOff}
          />
        )
        break
      case MODALS.CONFIRM_CODES:
      {
        const { composition } = client.readQuery({
          query: GET_CURRENT_COMPOSITION
        })
        const comp = JSON.parse(composition, null, 2)
        let sections = get(comp, 'sectionsS2', [])
        sections = sections.filter(s => !!s.diagnosisEntry)

        const dupeProblems = findDuplicates(sections.map(p => get(p, 'diagnosisEntry.diagnosis.icdCode', null)))
        dupeProblems.delete('')
        dupeProblems.size > 0 && setToast(TOAST.TYPE.WARNING, 'This note contains duplicate ICD-10 codes.', TOAST.DURATION.MEDIUM)

        modalContent = (
          <ConfirmCodeModal
            open={modal.open}
            shouldDismiss={this.state.shouldDismiss}
            loading={modal.loading}
            {...modal.content}
            removeModal={this.removeModal}
            dismiss={this.dismissOnCancel}
            problemSections={sections}
            dupeProblems={dupeProblems}
            handleContinue={this.onContinue}
            handleCodeClick={promptICD10Lookup}
            setToast={setToast}
          />
        )
        break
      }
      case MODALS.NEW_SCRIPT:
      {
        modalContent = (
          <NewScriptModal
            shouldDismiss={this.state.shouldDismiss}
            dismiss={this.dismissOnCancel}
            open={modal.open}
            removeModal={this.removeModal}
            sections={items}
          />
        )
        disableClickToDismiss = true
        break
      }

      case MODALS.NEW_NOTETYPE:
      {
        modalContent = (
          <NotetypeEditor
            shouldDismiss={this.state.shouldDismiss}
            dismiss={this.dismissOnCancel}
            open={modal.open}
            removeModal={this.removeModal}
            sections={items}
            isCreate
          />
        )
        disableClickToDismiss = true
        break
      }

      case MODALS.NOTETYPE_DETAIL:
      {
        modalContent = (
          <NotetypeEditor
            shouldDismiss={this.state.shouldDismiss}
            dismiss={this.dismissOnCancel}
            open={modal.open}
            removeModal={this.removeModal}
            sections={items}
            isCreate={false}
            cachedNoteType={noteType}
          />
        )
        disableClickToDismiss = true
        break
      }

      case MODALS.EMR_NOTE_PULL:
      {
        modalContent = (
          <EmrNotePullDialog
            shouldDismiss={this.state.shouldDismiss}
            dismiss={this.dismissOnCancel}
            open={modal.open}
            removeModal={this.removeModal}
          />
        )
        break
      }
      default:
        modalContent = (
          <ModalDialog
            open={modal.open}
            shouldDismiss={this.state.shouldDismiss}
            loading={modal.loading}
            {...modal.content}
            removeModal={this.removeModal}
            dismiss={this.dismissOnCancel}
            deleteNote={this.onDeleteNote}
            onAddPatientToList={this.onAddPatientToList}
            onAddPatientToSchedule={this.onAddPatientToSchedule}
            deleteProblemSection={this.onDeleteProblemSection}
            handleInactiveTimeout={this.onInactiveTimeout}
            submitNote={this.onSubmitNote}
            unfinishedNote={this.onClickUnfinishedNote}
            onSelect={handleSelect}
            secondaryHeader={secondaryHeader}
            bulkSaveNotes={this.onClickBulkSaveNotes}
            bulkPrintNotes={this.onClickBulkPrintNotes}
            handleCreateNewScript={this.createNewNoteType}
            selectType={get(modal, 'content.selectType')}
            redirectToSchedule={this.redirectToSchedule}
          />
        )
        break
    }

    return (
      <div>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          timeout={INACTIVITY_TIMEOUT}
          onIdle={this.handleOnIdle}
          onAction={this.handleOnAction}
          debounce={250}
        />
        <Veil active={active} disableClickToDismiss={disableClickToDismiss} dismiss={dismiss} dark={modal.open}>
          {modal.open ? modalContent : null}
        </Veil>
      </div>
    )
  }
}

const mapVeilToProps = ({ data: { veil } }) => ({
  active: veil && veil.active
})

const mapModalToProps = ({ data: { modal } }) => {
  return { modal }
}

const mapNotesListToProps = ({ data: { notesList } }) => ({
  compositionIds: notesList && notesList.compositionIds,
  patientNoteIds: notesList && notesList.patientNoteIds
})

export default compose(
  graphql(GET_VEIL, { props: mapVeilToProps }),
  graphql(GET_MODAL, { props: mapModalToProps }),
  graphql(GET_NOTES_LIST, { props: mapNotesListToProps }),
  graphql(CLEAR_MODAL, { name: 'clearModal' }),
  graphql(SET_MODAL_LOADING, {
    props: ({ mutate }) => ({
      setModalLoading: () => mutate()
    })
  }),
  graphql(SET_MODAL_DISMISS, {
    props: ({ mutate }) => ({
      setModalDismiss: () => mutate()
    })
  }),
  graphql(SET_MODAL, {
    props: ({ mutate }) => ({
      setModal: content => mutate({
        variables: { content }
      })
    })
  }),
  graphql(TOGGLE_VEIL, {
    props: ({ mutate }) => ({
      toggleVeil: active =>
        mutate({
          variables: { active }
        })
    })
  }),
  graphql(GET_AGENT_STATE, {
    props: ({ data: { agentState } }) => ({
      agentState
    })
  }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: agentPosition =>
        mutate({
          variables: { agentPosition }
        })
    })
  }),
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: agentSize =>
        mutate({
          variables: { agentSize }
        })
    })
  }),
  graphql(CLEAR_SECTION, {
    props: ({ mutate }) => ({
      clearCurrentSection: () => mutate()
    })
  }),
  graphql(GET_SCHEDULE_DATE, {
    props: ({ data: { scheduleDate } }) => ({
      scheduleDate: scheduleDate.date
    })
  }),
  graphql(SET_COMP_BEING_DELETED, {
    props: ({ mutate }) => ({
      setCompBeingDeleted: compBeingDeleted =>
        mutate({
          variables: { compBeingDeleted }
        })
    })
  }),
  graphql(SET_AUDIO_STREAM_UI_CONTEXT, {
    props: ({ mutate }) => ({
      setAudioStreamUIContext: audioStreamUIContext =>
        mutate({
          variables: { audioStreamUIContext }
        })
    })
  }),
  graphql(SET_AUDIO_STREAM_UI_CONTEXT, {
    props: ({ mutate }) => ({
      setAudioStreamContext: context => mutate({
        variables: { audioStreamUIContext: context }
      })
    })
  }),
  graphql(GET_DELETE_COMP_RES, {
    props: ({ data: { deleteCompResponse } }) => ({
      deleteCompResponse
    })
  }),
  graphql(UpdateComposition, { name: 'updateComposition' }),
  graphql(AddToPatientList, { name: 'addToPatientList' }),
  graphql(CreateOrUpdateAppointment, { name: 'updateAppointment' }),
  withRouter,
  withApollo
)(VeilContainer)
